import { Button } from "../../../design/button";
import { DialogActions, DialogBody, DialogTitle } from "../../../design/dialog";

interface Props {
  handleClose: () => void;
  onImportTypeSelected: (type: string) => void;
}

export interface ImportType {
  id: string;
  name: string;
  description: string;
  icon: React.ReactNode;
}

const importTypes: ImportType[] = [
  {
    id: "file",
    name: "Evidence",
    description: "Import evidence from a file",
    icon: <span>📄</span>,
  },
  {
    id: "filing",
    name: "Filing",
    description: "Import filing from a file",
    icon: <span>📂</span>,
  },
  {
    id: "csv",
    name: "CSV",
    description: "Import data from a CSV file",
    icon: <span>📊</span>,
  },
];

const SelectImportType: React.FC<Props> = ({
  handleClose,
  onImportTypeSelected,
}) => {
  return (
    <>
      <DialogTitle>Import</DialogTitle>
      <DialogBody>
        <div className="flex flex-col gap-4">
          {importTypes.map((type) => (
            <div
              key={type.id}
              className="flex items-center gap-4 p-4 border rounded cursor-pointer hover:bg-gray-100"
              onClick={() => onImportTypeSelected(type.id)}
            >
              {type.icon}
              <div>
                <h3 className="text-lg font-semibold">{type.name}</h3>
                <p className="text-sm text-gray-500">{type.description}</p>
              </div>
            </div>
          ))}
        </div>
      </DialogBody>
      <DialogActions>
        <Button type="button" onClick={handleClose}>
          Cancel
        </Button>
      </DialogActions>
    </>
  );
};

export default SelectImportType;
